export default "__VITE_ASSET__CB_kiRLz__"